import axios from '../../api/axios';
import { validateToken } from './validateAction';
import { showSuccess, showError } from '../../Components/reuse/Toast';

// Action types
export const CHANGE_LANGUAGE_REQUEST = 'CHANGE_LANGUAGE_REQUEST';
export const CHANGE_LANGUAGE_SUCCESS = 'CHANGE_LANGUAGE_SUCCESS';
export const CHANGE_LANGUAGE_FAILURE = 'CHANGE_LANGUAGE_FAILURE';

// Action creators
export const changeLanguageRequest = () => ({
  type: CHANGE_LANGUAGE_REQUEST
});

export const changeLanguageSuccess = (data) => ({
  type: CHANGE_LANGUAGE_SUCCESS,
  payload: data
});

export const changeLanguageFailure = (error) => ({
  type: CHANGE_LANGUAGE_FAILURE,
  payload: error
});

// Async action to change language settings
export const changeLanguage = (languageData) => async (dispatch) => {
  try {
    dispatch(changeLanguageRequest());
    
    const response = await axios.post('language/changeLanguage', languageData);
    
    // Show success message from API response
    if (response.data?.message) {
      showSuccess(response.data.message);
    }
    
    // Update auth data by validating token
    await dispatch(validateToken());
    
    dispatch(changeLanguageSuccess(response.data));
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to update language settings';
    dispatch(changeLanguageFailure(errorMessage));
    showError(errorMessage);
    throw error;
  }
};
